export default __webpack_public_path__ + "static/media/IDTEnquiryTemplate.43684152.xlsx";